import { vinyl_Icon } from "../../assets/icons";
import styles from "./LoadingSpinner.module.css";

function LoadingSpinner(props: { size?: number }) {
  const { size = 80 } = props;
  return (
    <img
      className={styles.pulse}
      src={vinyl_Icon}
      alt=""
      width={size}
      height={size}
    />
  );
}

export default LoadingSpinner;
